import { DetailsType, FormData } from 'types/application';
import { attachmentRetrieve } from '../helpers';
import { SECT_ORGANISATION, SECT_PUB_DETAILS, CONTACT_PUB } from 'common/application.const';
import { formatDateTime } from 'utils/application.helpers';

export const formatRetrieve = async (content: any, action?: string) => {
    const applicantValues = content.Organisation || {};
    const applicantContact = applicantValues.Contact || {};
    const publication = content?.Publication ?? {};
    const applicantAddress =
        applicantValues.Address && applicantValues.Address.length > 0 ? applicantValues.Address[0]?.MailingAddress || {} : {};
    let form = {};

    if (action === 'application-withdraw') {
        const withdrawForm = {
            id: 'application-withdraw',
            formID: 'application-withdraw',
            hasError: true,
            values: {
                title: publication.Title
            }
        };
        return [withdrawForm];
    }

    const valuesContact = {
        title: content.Title,
        [`${CONTACT_PUB}-office-no-country-code`]: applicantContact.OfficeNoCountryCode || '65',
        [`${CONTACT_PUB}-office-no-main`]: applicantContact.OfficeNo,
        [`${CONTACT_PUB}-mobile-no-country-code`]: applicantContact.MobileNoCountryCode || '65',
        [`${CONTACT_PUB}-mobile-no-main`]: applicantContact.MobileNo,
        [`${CONTACT_PUB}-email`]: applicantContact.EmailAddress,
        [`${CONTACT_PUB}-address-type`]: applicantAddress.AddressType || 'SG',
        [`${CONTACT_PUB}-postal`]: applicantAddress.PostalCode,
        [`${CONTACT_PUB}-block-house`]: applicantAddress.BlockNumber,
        [`${CONTACT_PUB}-street`]: applicantAddress.StreetName,
        [`${CONTACT_PUB}-floor`]: applicantAddress.FloorNumber,
        [`${CONTACT_PUB}-unit`]: applicantAddress.UnitNumber,
        [`${CONTACT_PUB}-building`]: applicantAddress.BuildingName
    };
    const orgForm = {
        id: 'organisation',
        formID: 'organisation',
        title: 'Applicant/Company Details',
        hasError: true,
        values: {
            // [`${SECT_APPLICANT}-id-type`]: orgValues.IDType,
            // [`${SECT_APPLICANT}-idno`]: orgValues.IDNo,
            // [`${SECT_APPLICANT}-salutaion`]: orgValues.Salutation,
            [`${SECT_ORGANISATION}-name`]: applicantValues.Person?.pyFullName,
            // [`${SECT_APPLICANT}-bday`]: formatDate(orgValues.DateOfBirth) ,
            [`${SECT_ORGANISATION}-nationality`]: applicantValues.Nationality,
            [`${SECT_ORGANISATION}-uen`]: applicantValues.UEN,
            [`${SECT_ORGANISATION}-company-name`]: applicantValues.CompanyName,
            [`${SECT_ORGANISATION}-mobile-no-country-code`]: applicantContact.MobileNoCountryCode || '65',
            [`${SECT_ORGANISATION}-mobile-no-main`]: applicantContact.MobileNo,
            [`${SECT_ORGANISATION}-office-no-country-code`]: applicantContact.OfficeNoCountryCode || '65',
            [`${SECT_ORGANISATION}-office-no-main`]: applicantContact.OfficeNo,
            [`${SECT_ORGANISATION}-email`]: applicantContact.EmailAddress,
            [`${SECT_ORGANISATION}-address-type`]: applicantAddress.AddressType || 'SG',
            [`${SECT_ORGANISATION}-postal`]: applicantAddress.PostalCode,
            [`${SECT_ORGANISATION}-block-house`]: applicantAddress.BlockNumber,
            [`${SECT_ORGANISATION}-street`]: applicantAddress.StreetName,
            [`${SECT_ORGANISATION}-floor`]: applicantAddress.FloorNumber,
            [`${SECT_ORGANISATION}-unit`]: applicantAddress.UnitNumber,
            [`${SECT_ORGANISATION}-building`]: applicantAddress.BuildingName
        }
    };

    const summary = {
        id: 'summary',
        formID: 'summary',
        hasError: true,
        values: {
            [`summary-title`]: publication.Title,
            [`summary-application-name`]: 'Publication',
            [`summary-id`]: content.caseid,
            [`summary-status`]: content.CustomerStatus,
            [`summary-date-submission`]: formatDateTime(content.pxCreateDateTime, true)
        }
    };

    if (action === 'contact-details') {
        form = {
            id: 'contact-details',
            formID: 'contact-details',
            hasError: true,
            values: valuesContact
        };
    } else {
        const pubForm = {
            id: 'publication',
            formID: 'publication',
            title: 'Publication Details',
            hasError: true,
            values: {
                [`${SECT_PUB_DETAILS}-publication-type`]: publication.Type,
                [`${SECT_PUB_DETAILS}-item-type`]: publication.ItemType,
                [`${SECT_PUB_DETAILS}-other-item-type`]: publication.OtherItemType,
                [`${SECT_PUB_DETAILS}-publication-title`]: publication.Title,
                [`${SECT_PUB_DETAILS}-romanized-title`]: publication.RomanizedTitle,
                [`${SECT_PUB_DETAILS}-isbn-no`]: publication.ISBNNo,
                [`${SECT_PUB_DETAILS}-issn-no`]: publication.ISSNNo,
                [`${SECT_PUB_DETAILS}-language`]: publication.Language,
                [`${SECT_PUB_DETAILS}-language-description`]: publication.LanguageDescription,
                [`${SECT_PUB_DETAILS}-issue-no`]: publication.IssueNo,
                [`${SECT_PUB_DETAILS}-author`]: publication.Author,
                [`${SECT_PUB_DETAILS}-artiste`]: publication.Artiste,
                [`${SECT_PUB_DETAILS}-publisher`]: publication.Publisher,
                [`${SECT_PUB_DETAILS}-volume-no`]: publication.VolumeNo,
                [`${SECT_PUB_DETAILS}-country-published`]: publication.Country,
                [`${SECT_PUB_DETAILS}-other-country`]: '',
                [`${SECT_PUB_DETAILS}-no-of-copies-imported`]: publication.ImportedCopies,
                [`${SECT_PUB_DETAILS}-reason-submission`]: publication.SubmissionReason,
                [`${SECT_PUB_DETAILS}-attachments`]: attachmentRetrieve(publication.AttachmentList),
                [`${SECT_PUB_DETAILS}-physical-copy`]: publication.PhysicalCopy || 'No',
                [`${SECT_PUB_DETAILS}-publication-id`]: publication.caseid,
                [`${SECT_PUB_DETAILS}-concatenated-title`]: publication.ConcatenatedTitle || '',
                [`${SECT_PUB_DETAILS}-link-to-attachments`]: publication.LinkToAttachments,
                [`${SECT_PUB_DETAILS}-ApplicationDate`]: publication.ApplicationDate,
                [`${SECT_PUB_DETAILS}-customer-status`]: content?.CustomerStatus ?? '',
                [`${SECT_PUB_DETAILS}-decision`]: (content?.Decision ?? ([] as any[])).pop() ?? {},
                WithdrawalDate: formatDateTime(content.WithdrawalDate, true ?? ''),
                WithdrawalRemarks: content.WithdrawalRemarks ?? '',
                CustomerStatus: content.CustomerStatus ?? '',
                ApplicationName: content?.pyLabel ?? ''
            }
        };
        return [summary, orgForm, pubForm];
    }

    return [form];
};

export const formatSave = async (details: DetailsType, action?: string) => {
    const contactDetails = details.forms.find((form: FormData) => form.id === 'contact-details')?.values || {};
    const eventWithdraw = details.forms.find((form: FormData) => form.id === 'application-withdraw')?.values || {};

    if (action === 'contact-details') {
        return {
            content: {
                Organisation: {
                    Address: [
                        {
                            MailingAddress: {
                                BlockNumber: contactDetails[`${CONTACT_PUB}-block-house`],
                                BuildingName: contactDetails[`${CONTACT_PUB}-building`],
                                FloorNumber: contactDetails[`${CONTACT_PUB}-floor`],
                                PostalCode: contactDetails[`${CONTACT_PUB}-postal`],
                                StreetName: contactDetails[`${CONTACT_PUB}-street`],
                                UnitNumber: contactDetails[`${CONTACT_PUB}-unit`]
                            }
                        }
                    ],
                    Contact: {
                        EmailAddress: contactDetails[`${CONTACT_PUB}-email`],
                        MobileNoCountryCode: contactDetails[`${CONTACT_PUB}-office-no-country-code`] || '65',
                        OfficeNoCountryCode: contactDetails[`${CONTACT_PUB}-mobile-no-country-code`] || '65',
                        MobileNo: contactDetails[`${CONTACT_PUB}-mobile-no-main`],
                        OfficeNo: contactDetails[`${CONTACT_PUB}-office-no-main`]
                    }
                }
            }
        };
    }
    if (action === 'application-withdraw') {
        return {
            content: {
                pyGotoStage: 'ALT2',
                WithdrawalRemarks: eventWithdraw[`aecWithdraw-reason`],
                WithdrawalDate: new Date()
            }
        };
    }
    return {};
};

const pubTitlePayload = {
    formatRetrieve,
    formatSave
};

export default pubTitlePayload;
